import React from 'react';
import Dict from 'dict-lib';
import {Button, FormGroup, FormControl, ControlLabel} from 'react-bootstrap';
import {SCCheckbox} from "../../dict-components/checkbox/SCCheckbox";

import stylesLanguageData from './../../_css/dictionary/languageData.module.css';
import BUtils from './../../utilities/BaseUtilities';
import {SCRadiobutton} from "../../dict-components/radiobutton/SCRadiobutton";
import stylesSearchMenu from "../../_css/dictionary/searchMenu.module.css";
import {userService} from "../../_redux/authentication/services/user.services";

export class EditLanguage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            dataObject: JSON.parse(JSON.stringify(this.props.data.dataObject)),
            selectedDescrLanguage: null
        };

        this._handleEditLangChange = this._handleEditLangChange.bind(this);
    }

    _handleEditLangChange(field, value) {
        var dataObject = this.state.dataObject;

        dataObject[field] = value;
        this.setState({dataObject});
        this.props.callBackChangeData(dataObject);
    }

    _retrieveComponentClass(field) {
        var sField = this.props.data.specialFields.find((specialField) => {
            return specialField.name === field;
        });

        return typeof sField !== 'undefined' && sField !== null ? sField.type : 'input';
    }

    _handleEditDescrLangChange(languageId, value) {
        var dataObject = this.state.dataObject;
        var descrByLanguage = this._getDescrByLanguage(languageId, dataObject);
        descrByLanguage.description = value;
        this.setState({dataObject});
        this.props.callBackChangeData(dataObject);
    }

    _getDescrByLanguage(languageId, dataObject) {
        dataObject = typeof dataObject === 'undefined' ? this.state.dataObject : dataObject;
        return dataObject.description.find((itemLang) => {
            return itemLang.languageId === languageId;
        });
    }


    render() {

        var components = this.state.dataObject === null ? '' : Object.keys(this.props.data.dataObject).map((field, index) => {
            var postFix = field + '-' + index;
            var dataField = this.state.dataObject[field];
            var label = Dict.t(BUtils.deCamel(field, "_").toUpperCase());
            var id = 'edit-lang-' + postFix;

            if (typeof dataField === 'string') {
                var componentClass = this._retrieveComponentClass(field);
                return <FormGroup key={'key-edit-lang-' + postFix} controlId={id}
                                  bsClass={BUtils.joinClasses(stylesLanguageData['edit-language-element'], stylesLanguageData[componentClass + '-group'])}>
                    <ControlLabel>{label}</ControlLabel>
                    <FormControl value={dataField} componentClass={componentClass}
                                 onChange={(event) => this._handleEditLangChange(field, event.target.value)}/>
                </FormGroup>
            } else if (typeof dataField === 'boolean') {
                return <SCCheckbox label={label} checked={dataField} id={id}
                                   additionalClass={BUtils.joinClasses(stylesLanguageData['edit-language-element'], stylesLanguageData['checkbox'])}
                                   callbackParent={(id, newState) => this._handleEditLangChange(field, newState)}/>
            } else if (Array.isArray(dataField)) {
                var cgrDescrItems = dataField.map((item) => {
                    return {label: item.language, code: item.languageId};
                });

                const langId = this.state.selectedDescrLanguage !== null ? this.state.selectedDescrLanguage : cgrDescrItems.find((cgrItem) => {
                    return cgrItem.code === (this.props.language.id + '');
                }).code;

                return <>
                    <FormGroup controlId="formControlsTextarea" className={stylesLanguageData['edit-language-textarea']}>
                        <ControlLabel>{Dict.t('DESCRIPTIONS_LABEL')}</ControlLabel>
                        <FormControl componentClass="textarea" placeholder="textarea"
                                     value={this._getDescrByLanguage(langId).description}
                                     onChange={(event) => this._handleEditDescrLangChange(langId, event.target.value)}/>
                    </FormGroup>
                    <SCRadiobutton key={"key-radio-insert-descriptioncgr"} id="dic-insert-descrcgr"
                                   label={''}
                                   items={cgrDescrItems}
                                   default={langId}
                                   callbackParent={(selectedDescrLanguage) => {
                                       this.setState({selectedDescrLanguage})
                                   }}/>
                </>;
            }
        });

        return <>
            {components}
        </>
    }
}